<template>
  <MainLayout page-name="fees-for-security">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="calculation" @click="clickCalculation">料金計算</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">補正登録</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true"/>
        <BillToCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" />
        <AirportCode v-model="simpleSearchFormModel.destination_airport_code" label="目的地"
          prop="destination_airport_code" :searchCond="true" :autocomplete-list="airportCodeSet" :initialize="true" />
        <RouteCode v-model="simpleSearchFormModel.route_code" :searchCond="true" :initialize="true" placeholder="線別" label="" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'bill_to_code', order: 'ascending' }"
      :selectable="deletable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <BillingYmColumn :sortable="true" />
        <BillToCodeColumn label="請求先" :sortable="true" />
        <AirportCodeColumn label="目的地" prop="destination_airport_code" :sortable="true" />
        <RouteCodeColumn :sortable="true" />
        <PaidPassengersColumn :sortable="true" />
        <PaidCargoVolumeColumn :sortable="true" /> -->
        <!-- <FeeColumn label="保安料（税抜き）" prop="security_fee_without_tax" :sortable="true" />
        <FeeColumn label="保安料（消費税額）" prop="security_fee_tax" :sortable="true" /> -->
        <!-- <FeeColumn label="保安料（税込）" prop="security_fee_with_tax" :sortable="true" :formatter="formatter" />
        <RegistTypeColumn :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
        <BillingYmColumn />
        <BillToCodeColumn label="請求先" />
        <AirportCodeColumn label="目的地" prop="destination_airport_code" />
        <RouteCodeColumn />
        <PaidPassengersColumn />
        <PaidCargoVolumeColumn />
        <!-- <FeeColumn label="保安料（税込）" prop="security_fee_with_tax" :formatter="formatter" /> -->
        <FeeColumn label="保安料（税抜）" prop="security_fee_without_tax" :formatter="formatter" />
        <RegistTypeColumn />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" />
      </template>
    </Table>
    <FeesForSecurityCalculationDialog
      :visible.sync="calculationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForSecurityRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <FeesForSecurityDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @search="detailSearch"
    />
    <FeesForSecurityEditDialog
      :visible.sync="editDialogVisible"
      :bill-to-code-set="billToCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import AirportCodeColumn from '@/components/molecules/table/AirportCodeColumn.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import PaidPassengersColumn from '@/components/molecules/table/PaidPassengersColumn.vue'
import PaidCargoVolumeColumn from '@/components/molecules/table/PaidCargoVolumeColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import RegistTypeColumn from '@/components/molecules/table/RegistTypeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import FeesForSecurityCalculationDialog from '@/components/pages/calculation/feesForSecurity/FeesForSecurityCalculationDialog.vue'
import FeesForSecurityRegisterDialog from '@/components/pages/calculation/feesForSecurity/FeesForSecurityRegisterDialog.vue'
import FeesForSecurityDetailSearchDialog from '@/components/pages/calculation/feesForSecurity/FeesForSecurityDetailSearchDialog.vue'
import FeesForSecurityEditDialog from '@/components/pages/calculation/feesForSecurity/FeesForSecurityEditDialog.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    BillToCode,
    AirportCode,
    RouteCode,
    SimpleSearch,
    Table,
    BillToCodeColumn,
    AirportCodeColumn,
    RouteCodeColumn,
    PaidPassengersColumn,
    PaidCargoVolumeColumn,
    FeeColumn,
    RegistTypeColumn,
    BlankColumn,
    MenuColumn,
    FeesForSecurityCalculationDialog,
    FeesForSecurityRegisterDialog,
    FeesForSecurityDetailSearchDialog,
    FeesForSecurityEditDialog
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '保安料',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: '',
        destination_airport_code: ''
      },
      currentRow: {},
      calculationDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForSecuritySearchCond')
    this.loadAirport()
    this.loadCustomer()
  },
  methods: {
    clickCalculation () {
      this.calculationDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('feesForSecuritySearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecuritySearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecuritySearchCond'))
      this.$axios
        .get('/search-fees-for-security', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecuritySearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('feesForSecuritySearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      const currentRow = { ...row }
      if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
        currentRow.billing_ym = ''
      }
      this.currentRow = currentRow
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/fees-for-security', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    },
    deletable (row, index) {
      // 削除可能条件
      return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()) || row.regist_type === '1')
    },
    /*
    formatter (row, column) {
      if (row.security_fee_with_tax !== null) {
        return String(row.security_fee_with_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
*/
    // 20220506髙森修正箇所 税込み→税抜き表示へ変更
    formatter (row, column) {
      if (row.security_fee_without_tax !== null) {
        return String(row.security_fee_without_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
